module.exports = "<a href=\"{{ getPartnerLink() }}{{ partnerUrlTranslationKey  | translate: { partner: getPartner() } }}\" target=\"_blank\">\n    »&nbsp;<span class=\"textlink\" translate>{{ translationKey }}</span>\n</a>"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/quoteandbind/mfp/directives/templates/mfp-partner-link.html
// module id = 601
// module chunks = 0